/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Tournament_Wiz_Tip_Discord_None_BInputs */



/**
* | output |
* | --- |
* | "Put the meeting place in {field}. Players register and check in from the app, and you announce each round start from the console." |
*
* @param {Tournament_Wiz_Tip_Discord_None_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_discord_none_b = /** @type {((inputs: Tournament_Wiz_Tip_Discord_None_BInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Discord_None_BInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Indiquez le lieu de rendez-vous dans ${i?.field}. Les joueurs s'inscrivent et pointent depuis l'application, et vous annoncez chaque début de ronde depuis la console.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ponga el punto de encuentro en ${i?.field}. Los jugadores se inscriben y hacen check-in desde la aplicación, y usted anuncia el comienzo de cada ronda desde la consola.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Coloque o ponto de encontro em ${i?.field}. Os jogadores se inscrevem e fazem check-in pelo aplicativo, e você anuncia o início de cada rodada pelo console.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Metti il punto d'incontro in ${i?.field}. I giocatori si iscrivono e fanno il check-in dall'app, e tu annunci l'inizio di ogni round dalla console.`)
	return /** @type {LocalizedString} */ (`Put the meeting place in ${i?.field}. Players register and check in from the app, and you announce each round start from the console.`)
});